(() => {
  'use strict';
  const element = document.getElementById('cjnz-countdown-config');
  const strip = document.querySelector('[data-cjnz-festive-strip]');
  if (!element || !strip) return;
  let config;
  try { config = JSON.parse(element.textContent); } catch (_) { return; }
  const calendarDate = value => {
    const match = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value || '');
    if (!match) return null;
    const year = Number(match[1]), month = Number(match[2]), day = Number(match[3]);
    const date = new Date(Date.UTC(year, month - 1, day));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day ? date.getTime() : null;
  };
  const target = calendarDate(config.targetDate);
  const seasonEnd = calendarDate(config.seasonEnd);
  const container = strip.querySelector('[data-cjnz-countdown]');
  const number = strip.querySelector('[data-cjnz-countdown-number]');
  const label = strip.querySelector('[data-cjnz-countdown-label]');
  const passedDates = Array.from(strip.querySelectorAll('[data-cjnz-date-passed]'));
  const expired = strip.querySelector('[data-cjnz-dates-expired]');
  let formatter;
  try { formatter = new Intl.DateTimeFormat('en-NZ', { timeZone: config.timeZone, year: 'numeric', month: '2-digit', day: '2-digit' }); } catch (_) { return; }
  let timer;
  function update() {
    const parts = Object.fromEntries(formatter.formatToParts(new Date()).map(part => [part.type, part.value]));
    const today = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day));
    strip.hidden = seasonEnd !== null && today > seasonEnd;
    if (strip.hidden) {
      const shipping = strip.querySelector('.cjnz-shipping-banner__offer');
      if (shipping) strip.parentElement.insertBefore(shipping, strip);
      clearInterval(timer);
      return;
    }
    let anyPassed = false;
    passedDates.forEach(item => {
      const date = calendarDate(item.getAttribute('data-cjnz-date-passed'));
      item.hidden = date === null || today <= date;
      anyPassed = anyPassed || !item.hidden;
    });
    if (expired) expired.hidden = !anyPassed;
    const remaining = target === null ? -1 : Math.round((target - today) / 86400000);
    container.hidden = !config.enabled || remaining < 0;
    if (container.hidden) return;
    const count = remaining === 0 ? '' : String(remaining);
    const message = remaining === 0 ? config.christmasDay : remaining === 1 ? config.oneDayLabel : config.daysLabel;
    number.hidden = remaining === 0;
    if (number.textContent !== count) number.textContent = count;
    if (label.textContent !== message) label.textContent = message;
  }
  update();
  if (!strip.hidden) timer = setInterval(update, 60000);
  window.addEventListener('pageshow', update);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const details = strip.querySelector('details[open]');
    if (!details) return;
    const hadFocus = details.contains(document.activeElement);
    details.open = false;
    if (hadFocus) details.querySelector('summary').focus();
  });
})();
